import { Spin } from "antd";
import type { FC } from "react";
import { useParams } from "react-router";

import { TerminalImportLogMessageCard } from "src/app/features/TerminalImportLog/components/forms/TerminalImportLogMessageCard";
import { TerminalImportLogItemTable } from "src/app/features/TerminalImportLog/components/tables/TerminalImportLogItemTable";
import { useTerminalImportLogLoadQuery } from "src/app/features/TerminalImportLog/services/server/TerminalImportLogApi";
import type { NoneOwnProps } from "../../../../../core/types";

export const TerminalImportLogViewForm: FC<NoneOwnProps> = () => {
    const { id } = useParams();
    const { data: loadFormData, isFetching: loadFormIsInProgress } = useTerminalImportLogLoadQuery({ entityId: id });

    return (
        <Spin spinning={loadFormIsInProgress}>
            <TerminalImportLogMessageCard log={loadFormData} />
            <TerminalImportLogItemTable id={id} />
        </Spin>
    );
};
